import type { LotteryPrize } from './types'

export function lotteryRewardText(prize: Partial<LotteryPrize>) {
  const rewards: string[] = []
  if (Number(prize.giftBalance || 0) > 0) rewards.push(`赠￥${number(prize.giftBalance)}`)
  if (Number(prize.points || 0) > 0) rewards.push(`柴火+${Number(prize.points)}`)
  if (Number(prize.snackCoupon || 0) > 0) rewards.push(`小吃券+${Number(prize.snackCoupon)}`)
  if (Number(prize.wineCoupon || 0) > 0) rewards.push(`酒水券+${Number(prize.wineCoupon)}`)
  return rewards.slice(0, 2).join(' ') || '谢谢参与'
}

export function wheelTargetRotation(current: number, prizeIndex: number, prizeCount: number) {
  const count = Math.max(1, prizeCount)
  const step = 360 / count
  const target = normalize(-((Math.max(0, prizeIndex) + 0.5) * step))
  return current + 1440 + normalize(target - normalize(current))
}

export function lotteryPrizeSummary(prizes: Array<Pick<LotteryPrize, 'name'>>) {
  const counts = new Map<string, number>()
  for (const prize of prizes) counts.set(prize.name, (counts.get(prize.name) || 0) + 1)
  return [...counts.entries()].map(([name, count]) => count > 1 ? `${name}×${count}` : name).join('、')
}

function normalize(value: number) {
  return ((value % 360) + 360) % 360
}

function number(value: unknown) {
  return Number(value || 0).toFixed(2).replace(/\.00$/, '')
}
